import { useCallback, useState } from 'react';

import { calculateTotalPages } from '../utils/calculate-total-page';

export type PaginationParams = {
	limit: number;
	total: number;
};

export function usePagination<T>({ limit, total = 0 }: PaginationParams) {
	const maxPages = calculateTotalPages(total, limit);
	// TODO: Get initial page from router query, then fetch data with the initial page. Atm, we are always on page 1 so there is 1 redundant request
	const [page, setPage] = useState(1);
	const offsetPages = page - 1;
	const offsetItems = offsetPages * limit;

	const goToPage = useCallback((selectedPage: number) => {
		if (selectedPage < 1 || selectedPage > maxPages) {
			console.warn(`Cannot switch to page ${selectedPage}. Current page is ${page}. Max pages: ${maxPages}`);

			if (maxPages === 0) {
				console.warn('No pages available. Setting page to 1');
				setPage(1);
			}

			return;
		}

		setPage(selectedPage);
	}, [page, maxPages]);

	return {
		page,
		limit,
		offsetPages,
		offsetItems,
		maxPages,
		setPage,
		nextPage: () => goToPage(page + 1),
		prevPage: () => goToPage(page - 1),
		firstPage: () => goToPage(1),
		lastPage: () => goToPage(maxPages),
		toPage: (pageNumber: number) => goToPage(pageNumber),
		/**
		 * This function should only be used if you want to use frontend pagination.
		 */
		getPaginatedData: (data: T[]) => data.slice(offsetItems, offsetItems + limit),
	};
}
